var _rect, _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactIcon = function SvgContactIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#E6ECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 37.7143C86 31.7969 81.2031 27 75.2857 27H36.7143C30.797 27 26 31.7969 26 37.7143V76.2857C26 82.203 30.797 87 36.7143 87H75.2857C81.2031 87 86 82.203 86 76.2857V37.7143ZM75.2857 31.2857C78.8361 31.2857 81.7143 34.1639 81.7143 37.7143V76.2857C81.7143 79.8361 78.8361 82.7143 75.2857 82.7143H36.7143C33.1639 82.7143 30.2857 79.8361 30.2857 76.2857V37.7143C30.2857 34.1639 33.1639 31.2857 36.7143 31.2857H75.2857Z",
    fill: "#2E726E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 42C58.7614 42 61 44.2386 61 47C61 49.7614 58.7614 52 56 52C53.2386 52 51 49.7614 51 47C51 44.2386 53.2386 42 56 42ZM66 47C66 41.4772 61.5229 37 56 37C50.4772 37 46 41.4772 46 47C46 52.5228 50.4772 57 56 57C61.5229 57 66 52.5228 66 47Z",
    fill: "#2E726E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 74.5C71 67.5964 65.4036 62 58.5 62H53.5C46.5964 62 41 67.5964 41 74.5V77H46V74.5C46 70.3579 49.3579 67 53.5 67H58.5C62.6421 67 66 70.3579 66 74.5L66 77H71L71 74.5Z",
    fill: "#2E726E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 75,
    r: 20,
    fill: "#2E726E",
    stroke: "#E6ECEC",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7798 68.1175C77.5098 67.4426 76.8562 67 76.1292 67H73.6842C72.754 67 72 67.7539 72 68.684C72 76.5904 78.4094 83 86.3156 83C87.2457 83 87.9996 82.2459 87.9996 81.3157L88 78.8702C88 78.1433 87.5575 77.4897 86.8826 77.2197L84.5392 76.2826C83.9329 76.0401 83.2426 76.1493 82.741 76.5673L82.1362 77.0717C81.4299 77.6604 80.3906 77.6135 79.7404 76.9634L78.0374 75.2587C77.3872 74.6086 77.3392 73.5701 77.9278 72.8637L78.4321 72.2589C78.8501 71.7573 78.9603 71.0668 78.7177 70.4605L77.7798 68.1175Z",
    stroke: "#AFDFDC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgContactIcon as ReactComponent };